// import Vue from 'vue'

import firebase from 'firebase';

const actions =	{
	verifyEmail(){
		firebase.auth().currentUser.sendEmailVerification().then(function() {
			console.log("Verification email sent.")
		})
		.catch(function(error) {
			console.log(error)
		});
	}, 
	verifyUserEmail({dispatch}, id){
		return new Promise((resolve, reject) => {
			var functions = firebase.app().functions('europe-west1');
			var getEmailVerificationLink = functions.httpsCallable('getEmailVerificationLink');
			getEmailVerificationLink(id).then( (link) => {
				dispatch("addDoc",  {
					collection: "emails", 
					data: {
						to: id, 
						message: {
							text: `Hello here is a link: \n: ${link.data}`,
							subject: "Verify your checkit now account"
						}

					}
				}).then( ref => {
					resolve({link: link, mail: ref.id});
				}).catch( error	 => {
					reject(error	)
				})
			}).catch((error) => {
				reject(error)
			})
		})
	}, 
	sendPasswordResetEmail({dispatch}, email){
		dispatch;
		return new Promise((resolve, reject) => {
			firebase.auth().sendPasswordResetEmail(email).then(function() {
				resolve();			
			})
			.catch(function(error) {
				reject(error)
			});
		})
	},
	contactFormEmail({dispatch}, message ){
		message.to = "rebecca.hawkins@m.works";
		message.type = "contact_form_message";
		var intro = `This is a contact form message from checkit-now user ${message.name} (${message.email}) \n`
		message.message = intro + message.content;
		dispatch("addDoc",  {
			collection: "emails", 
			data: message
		}, {root: true }).then( () => {
			return true;
		})
	}
}
export default {
	namespaced: true,
	actions: actions
}